export default __webpack_public_path__ + "static/couples-suite-valentine-9fb00ff8a8d15aa70b762289bdbffecc.jpg";